module.exports = __webpack_public_path__ + "static/img/ios_yo.429a17d7.png";